export default "__VITE_PUBLIC_ASSET__dd34669f__"